import { CommonModule } from '@angular/common';
import { Component, inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ScenePath } from '@models';
import { AppService, MessageService } from '@services';
import { DialogModule } from 'primeng/dialog';
import { SceneStore } from '@stores';
import { AngularSvgIconModule } from 'angular-svg-icon';

@Component({
  selector: 'bo-scene-launcher',
  templateUrl: './scene-launcher.component.html',
  standalone: true,
  imports: [AngularSvgIconModule, CommonModule, FormsModule, DialogModule],
})
export class SceneLauncherComponent {
  appService = inject(AppService);
  #messageService = inject(MessageService);
  #sceneStore = inject(SceneStore);

  ScenePath = ScenePath;
  selectedScene: ScenePath = null;
  showLoader = signal(false);

  showSceneLauncher = this.appService.showSceneLauncher;

  toggleSceneLauncher() {
    this.appService.showSceneLauncher.set(!this.appService.showSceneLauncher());
  }

  selectScene(scene: ScenePath) {
    this.selectedScene = scene;
    this.showLoader.set(true);
    this.toggleSceneLauncher();
    this.sceneSetup(scene);
  }

  selectDemo(scene: ScenePath) {
    this.selectedScene = scene;
    this.showLoader.set(true);
    this.appService.demoMode.set(true);
    this.showLoader.set(false);
    this.toggleSceneLauncher();
    this.sceneSetup(scene);
  }

  sceneSetup(scene: ScenePath) {
    this.#messageService.clearMessages();
    this.#sceneStore.selectScene(scene);
  }
}
